export const PROTECTED_API_ENDPOINTS: readonly string[] = [
    'users/me',
    'reminders/getRemindersByAccountMappingsId',
    'watchers/getMyWatchers',
    // Chatbox subject list (GET /notifications/user-messages/topics) — bearer
    // protected; must not go out without an app JWT or the 403 logs the user out.
    'user-messages/topics',
];

export const AUTH0_PROTECTED_ENDPOINTS: readonly string[] = [
    'sso-login',
    'createUserAccount',
    'checkUsernameExists',
];

// Error types that should trigger a logout
export const CRITICAL_ERROR_TYPES: readonly string[] = [
    'login_required',
    'invalid_grant',
    'token_expired',
    'invalid_token',
    'masquerade_session_expired',
];

export const NO_AUTH_ENDPOINTS: readonly string[] = ['refresh'];
